import DeparturesList from './DeparturesList';
import { useTripWithDepartures } from 'src/hooks/useTripWithDepartures';
import { filterDepartures } from 'src/services/departures/departures.utils';
import { useSelectedDateRanges } from 'src/hooks/useSelectedDateRanges';
import { useMemo } from 'react';
import { deserializeTripDeparture } from 'src/services/departures/departures.requests';

export interface DepartureListMapperProps {
  tripCode: string;
}

const DepartureListMapper: React.FC<DepartureListMapperProps> = ({ tripCode }) => {
  const { selectedDateRanges } = useSelectedDateRanges();
  const { data: trip } = useTripWithDepartures({ code: tripCode });

  const departures = useMemo(() => {
    if (!trip || !selectedDateRanges) return undefined;
    return filterDepartures(
      trip.tripDepartures.map(deserializeTripDeparture),
      selectedDateRanges,
    );
  }, [trip, selectedDateRanges]);

  if (!departures || !trip) return null;

  return (
    <DeparturesList
      matchingDepartures={departures}
      allDeparturesCount={trip.tripDepartures?.length ?? 0}
      trip={trip}
    />
  );
};

export default DepartureListMapper;
